<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <template v-if="isDisconnected">
            <v-chip color="#a13493" small>Disconnected</v-chip>
          </template>
          <template v-else>
            <v-chip :color="msColor(avgPingMs)" small style="white-space: nowrap">{{ msDisplay }} ms
              <template v-if="nPingsWaiting >= 2">({{ nPingsWaiting }})</template>
            </v-chip>
          </template>
        </span>
      </template>
      <div v-if="isDev">
        <div v-for="ping of userPingData" style="width: 100%;" class="pa-2 d-flex align-center" :key="ping.username">
          <span>{{ ping.ip_address }} || {{ ping.username }} <v-chip small :color="msColor(ping.avg_ping_ms)">{{ ping.avg_ping_ms }} ms</v-chip></span>
          <span class="ml-2">
            <v-icon small color="green">mdi-arrow-up-bold</v-icon> {{ getSentBandwidthRate(ping.bandwidth) }}/s
            <v-icon small color="red">mdi-arrow-down-bold</v-icon> {{ getReceivedBandwidthRate(ping.bandwidth) }}/s
          </span>
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

  export default {
    name: "NetworkStatus",

    data() {
      return {

      }
    },

    computed: {
      ...mapState([
        'userPingData',
        'isDisconnected',
      ]),
      ...mapGetters([
        'avgPingMs',
        'nPingsWaiting',
        'isDev'
      ]),

      msDisplay() {
        if (this.avgPingMs === null) {
          return '...';
        }

        return Math.round(this.avgPingMs);
      },

    },

    methods: {
      formatNumber(v, _d=1) {
        if (!v) return v;
        return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      },

      msColor(ping) {
        if (this.nPingsWaiting >= 5) {
          // on the verge of disconnecting
          return '#a13493';
        }

        if (ping === null) {
          return 'gray';
        }

        if (ping < 500) {
          return 'green';
        }

        if (ping < 2000) {
          return 'orange';
        }

        return 'red';
      },

      getPrettyBandwidth(bytes) {
        if (bytes >= 1024 && bytes < 1048576) return `${this.formatNumber(bytes / 1024)}kb`;
        if (bytes >= 1048576) return `${this.formatNumber(bytes / 1048576)}mb`;

        return `${this.formatNumber(bytes)}b`;
      },

      getSentBandwidth(bandwidth) {
        let sent = 0;

        if (bandwidth.socket) sent += bandwidth.socket.sent || 0;
        if (bandwidth.http) sent += bandwidth.http.sent || 0;

        return this.getPrettyBandwidth(sent);
      },

      getReceivedBandwidth(bandwidth) {
        let received = 0;

        if (bandwidth.socket) received += bandwidth.socket.received || 0;
        if (bandwidth.http) received += bandwidth.http.received || 0;

        return this.getPrettyBandwidth(received);
      },

      getSentBandwidthRate(bandwidth) {
        let sent = 0;

        if (bandwidth.socket) sent += bandwidth.socket.sent_rate || 0;
        if (bandwidth.http) sent += bandwidth.http.sent_rate || 0;

        return this.getPrettyBandwidth(sent);
      },

      getReceivedBandwidthRate(bandwidth) {
        let received = 0;

        if (bandwidth.socket) received += bandwidth.socket.received_rate || 0;
        if (bandwidth.http) received += bandwidth.http.received_rate || 0;

        return this.getPrettyBandwidth(received);
      },
    }
  }
</script>

<style scoped>

</style>
